module.exports = __webpack_public_path__ + "media/เดินออกประตูไปค่ะ.cb16be36.mp3";